import React from "react";
import { Link, useParams } from "react-router-dom";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useState } from "react";
import moment from "moment";
import { MdLocationOn } from 'react-icons/md';

// components
import AuthHeader from "../components/Headers/AuthHeader.component";
import Footer1 from "../components/Footers/Footer1.component";
import MyJobPost from "../components/Jobs/MyJobPost.component";
import Loader from '../components/Loader.component';
import ReactImageFallback from "react-image-fallback";

// images
import defaultUser from "../assets/images/default_profile_pic.jpg";
import SingleBid from "../components/SingleBid.component";

export default function BidsList() {

  const queryString = window.location.search;
  // const urlParams = new URLSearchParams(queryString);
  // const post_id = urlParams?.get('post_id');
  // const bid_id = urlParams?.get('bid_id');

  // Local State
  const [bids, setBids] = useState("");
  const [action, setAction] = useState("");

  // Redux State
  const token = useSelector((state) => state.auth.token);
  const userData = useSelector((state) => state.auth.data);

  useEffect(() => {
    getAllPosts();
  }, [token]);

  const getAllPosts = async () => {
    await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/bids?${queryString}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((r) => r.json())
      .then((response) => {
        if (response) {
          setBids(response.records.data);
          console.log(response);
        } else {
          console.log(response);
        }
      });
  };

  return (
    <>
      <AuthHeader />

      {!bids ? (
        <Loader />
      ) : (
        <section className="bds-main-section">
          <div className="container">
            <div className="row align-items-start">
              <div className="bds-featureRating">
                <h3 className="mb-3">Bids List</h3>
              </div>
              {/* Single Bid Starts */}
                {
                  bids?.map((bid, idx) =>
                    <div className="col-lg-5">
                      <SingleBid
                        key={idx}
                        idx={idx}
                        bid={bid}
                        token={token}
                        setAction={setAction}
                      />
                    </div>
                  )
                }
                    
                  {/* Single Bid Ends */}


            </div>
          </div>
        </section>
      )}

      <Footer1 />
    </>
  );
}
